<iframe *ngIf="safeSource" [src]="safeSource"></iframe>



// WEBPACK FOOTER //
// ./src/app/core/achoo-iframe/achoo-iframe.component.html